import Vue from 'vue'
import store from "@/store"

var UserSelectPromptContent = Vue.extend({
  template: `
  <div>
    <user-selector
      v-if="selection === null"
      size="small"
      @select="onUserHandleSelect"
    />
    <p class="m-2" v-if="selection">
      <strong>Selected user:</strong> {{selection.displayName}} ({{selection.value}})
    </p>
  </div>
  `,
  beforeCreate() {
    this.$store = store;
  },
  data: () => ({
    selection: null
  }),
  methods: {
    onUserHandleSelect(selection) {
      this.selection = selection;
    },
    reset() {
      this.selection = null;
    }
  }
})

export default {
  methods: {
    $user_prompt({ title } = {}) {
      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: title || 'Select a user',
          message: this.$createElement(UserSelectPromptContent, {}),
          showCancelButton: true,
          beforeClose: (action, instance, done) => {

            let dataContainer = instance.$children.find( child => 'selection' in child )

            let done_with_reset = () => {
              done();
              dataContainer.reset();
            }

            if ( action !== 'confirm' || !dataContainer.selection ) {
              done_with_reset();
              // reject(new Error('cancel'));
              return
            }

            resolve({
              done: done_with_reset,
              ...dataContainer._data
            })
          }
        }).catch(e => e);
      })
    }
  }
}
